import { CopyTimeclockScheduleResponse, TimeclockScheduleResponse, TimeclockSheetResponse, TimeclockShiftListResponse, CreateTimeclockDeviceResponse, TimeclockBranchSettingResponse, TimeclockDeviceListResponse, TimeclockMemberListResponse, TimeclockMemberResponse, TimeclockTodayResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/timeclock` — o ponto dos funcionários, do lado do gerente (F339).
 *
 * O aparelho que bate o ponto não passa por aqui: ele tem a credencial dele e
 * fala com `/api/v1/timeclock/device` (ver `apps/web/src/lib/ponto-device.ts`).
 */
export const fetchTimeclockMembers = async (signal) => TimeclockMemberListResponse.parse(await request('/api/v1/timeclock/members', { signal }));
export const createTimeclockMember = async (input) => TimeclockMemberResponse.parse(await request('/api/v1/timeclock/members', { method: 'POST', body: input }));
export const saveTimeclockMember = async (employeeId, input) => TimeclockMemberResponse.parse(await request(`/api/v1/timeclock/members/${employeeId}`, {
    method: 'PUT',
    body: input,
}));
export const uploadTimeclockMemberPhoto = async (employeeId, photo) => {
    const body = new FormData();
    body.append('file', photo, 'foto.jpg');
    return TimeclockMemberResponse.parse(await request(`/api/v1/timeclock/members/${employeeId}/photo`, {
        method: 'POST',
        body,
    }));
};
export const unlockTimeclockMember = async (employeeId) => TimeclockMemberResponse.parse(await request(`/api/v1/timeclock/members/${employeeId}/unlock`, {
    method: 'POST',
    body: {},
}));
export const fetchTimeclockDevices = async (signal) => TimeclockDeviceListResponse.parse(await request('/api/v1/timeclock/devices', { signal }));
/** Pareia um aparelho, e devolve o token uma vez só. */
export const createTimeclockDevice = async (input) => CreateTimeclockDeviceResponse.parse(await request('/api/v1/timeclock/devices', { method: 'POST', body: input }));
export const revokeTimeclockDevice = async (id, reason) => TimeclockDeviceListResponse.parse(await request(`/api/v1/timeclock/devices/${id}/revoke`, {
    method: 'POST',
    body: { reason },
}));
export const fetchTimeclockBranchSetting = async (branchId, signal) => TimeclockBranchSettingResponse.parse(await request(`/api/v1/timeclock/branches/${branchId}/setting`, { signal }));
export const saveTimeclockBranchSetting = async (branchId, input) => TimeclockBranchSettingResponse.parse(await request(`/api/v1/timeclock/branches/${branchId}/setting`, {
    method: 'PUT',
    body: input,
}));
export const fetchTimeclockToday = async (branchId, signal) => TimeclockTodayResponse.parse(await request(`/api/v1/timeclock/today${branchId === null ? '' : `?branchId=${branchId}`}`, { signal }));
/** Inclui a batida esquecida ou anula uma errada (F340). */
export const createTimeclockAdjustment = async (input) => {
    await request('/api/v1/timeclock/adjustments', {
        method: 'POST',
        body: input,
    });
};
/** O espelho do mês de um funcionário (`month` = `YYYY-MM`). */
export const fetchTimeclockSheet = async (employeeId, month, signal) => TimeclockSheetResponse.parse(await request(`/api/v1/timeclock/sheet?employeeId=${employeeId}&month=${month}`, { signal }));
export const fetchTimeclockShifts = async (signal) => TimeclockShiftListResponse.parse(await request('/api/v1/timeclock/shifts', { signal }));
export const createTimeclockShift = async (input) => TimeclockShiftListResponse.parse(await request('/api/v1/timeclock/shifts', { method: 'POST', body: input }));
export const updateTimeclockShift = async (id, input) => TimeclockShiftListResponse.parse(await request(`/api/v1/timeclock/shifts/${id}`, {
    method: 'PUT',
    body: input,
}));
/** A escala da semana (`week` = qualquer dia dela) de uma loja (F341). */
export const fetchTimeclockSchedule = async (week, branchId, signal) => TimeclockScheduleResponse.parse(await request(`/api/v1/timeclock/schedule?week=${week}&branchId=${branchId}`, { signal }));
export const saveTimeclockSchedule = async (input) => {
    await request('/api/v1/timeclock/schedule', { method: 'PUT', body: input });
};
export const copyTimeclockSchedule = async (input) => CopyTimeclockScheduleResponse.parse(await request('/api/v1/timeclock/schedule/copy', {
    method: 'POST',
    body: input,
}));
//# sourceMappingURL=timeclock.js.map